<div class="container">
    <div class="header">
        <div class="text">{{title}}</div>
        <div class="bill" *ngIf="bill">
            <a [routerLink]="['/print-invoice']">
                Print Invoice
            </a>
        </div>
        <div class="bill" *ngIf="result">
            <a [routerLink]="['/print-receipt']">
                Print receipt
            </a>
        </div>
    </div>
    <div class="body">
        <ng-content></ng-content>
    </div>
</div>
